import React, { lazy } from "react";
import { pages } from "./config";
import { APP_FEATURES, type AppFeatureKey } from "./features";
import HomeView from "../Views/Home/Home";

const SmartNotFound = lazy(() => import("../Views/SmartNotFound"));
const ConnectRedirectView = lazy(
  () => import("../Views/ConnectRedirect/ConnectRedirect")
);
const ExploreAddOnsView = lazy(
  () => import("../Views/ExploreAddOns/ExploreAddOns")
);
const TermsOfServiceView = lazy(
  () => import("../Views/Legal/TermsOfService")
);
const PrivacyPolicyView = lazy(
  () => import("../Views/Legal/PrivacyPolicy")
);
const RefundPolicyView = lazy(
  () => import("../Views/Legal/RefundPolicy")
);
const PricingView = lazy(() => import("../Views/Pricing"));
const AboutView = lazy(() => import("../Views/About"));
const AddOnsSuggestionsView = lazy(
  () => import("../Views/Forms/Suggestions")
);
const DocsView = lazy(() => import("../Views/Docs"));
const HelpView = lazy(() => import("../Views/Help/Help"));
const AddOnsSuggestionsTest = lazy(
  () => import("../Views/Forms/SuggestionsTest")
);
const PayView = lazy(() => import("../Views/Pay"));

export type Route = {
  path: string;
  element: React.ReactElement;
  exact?: boolean;
  isGuarded?: boolean;
  routes?: Route[];
  fallback?: string;
  key?: string;
  name?: string;
  icon?: React.ReactNode;
  featureKey?: AppFeatureKey;
};

const routes: Route[] = [
  {
    path: pages.HOME_PAGE.url,
    element: <HomeView />,
    exact: true,
    isGuarded: false,
  },
  {
    path: pages.PRICING_PAGE.url,
    element: <PricingView />,
    exact: true,
    isGuarded: false,
  },
  {
    path: pages.ABOUT_PAGE.url,
    element: <AboutView />,
    exact: true,
    isGuarded: false,
  },
  {
    path: pages.PAY_PAGE.url,
    element: <PayView />,
    exact: false,
    isGuarded: false,
  },
  {
    path: pages.EXPLORE_ADD_ONS_PAGE.url,
    element: <ExploreAddOnsView />,
    exact: true,
    isGuarded: false,
    featureKey: APP_FEATURES.ADD_ONS,
  },
  {
    path: pages.PAGE_NOT_FOUND_PAGE.url,
    element: <SmartNotFound />,
    exact: true,
    isGuarded: false,
  },
  {
    path: pages.TERMS_OF_SERVICE_PAGE.url,
    element: <TermsOfServiceView />,
    exact: true,
    isGuarded: false,
  },
  {
    path: pages.PRIVACY_POLICY_PAGE.url,
    element: <PrivacyPolicyView />,
    exact: true,
    isGuarded: false,
  },
  {
    path: pages.REFUND_POLICY_PAGE.url,
    element: <RefundPolicyView />,
    exact: true,
    isGuarded: false,
  },
  {
    path: pages.ADD_ON_SUGGESTIONS_FORM_PAGE.url,
    element: <AddOnsSuggestionsView />,
    exact: true,
    isGuarded: false,
  },
  {
    path: pages.BUG_REPORT_FORM_PAGE.url,
    element: <AddOnsSuggestionsTest />,
    exact: true,
    isGuarded: false,
  },
  {
    path: pages.DOCS_PAGE.url,
    element: <DocsView />,
    exact: true,
    isGuarded: false,
  },
  {
    path: pages.HELP_PAGE.url,
    element: <HelpView />,
    exact: true,
    isGuarded: false,
  },
  {
    path: "/connect/*",
    element: <ConnectRedirectView />,
    exact: false,
    isGuarded: false,
  },
  {
    path: "*",
    element: <SmartNotFound />,
    exact: false,
    isGuarded: false,
  },
];

export default routes;
